// extracted by mini-css-extract-plugin
module.exports = {"brightCoveContainer":"BrightCove_brightCoveContainer__2I9Wh","brightCoveVideo":"BrightCove_brightCoveVideo__Y-2ff"};